export const ROUTER_PATH = {
  MAIN: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  SIGNUP_REQUEST: '/signup/request',
  RESET_PW_VERIFY: '/reset-password/verify',
  RESET_PW_REQUEST: '/reset-password/request',
  RESET_PW_CHANGE: '/reset-password/change',
  ACCOUNT: '/account',
  UPLOAD: '/upload',
  TEXT_UPLOAD: '/upload/text',
  ABOUT: '/about',
  RESULTS: '/results',
  DETECT_RESULT: '/detect-result',
  BYPASS_RESULT: '/bypass-result',
};
